var p = Object.defineProperty;
var C = (s, e, t) =>
  e in s
    ? p(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
    : (s[e] = t);
var i = (s, e, t) => (C(s, typeof e != 'symbol' ? e + '' : e, t), t);
import {
  markRaw as d,
  ref as a,
  onActivated as m,
  onDeactivated as N,
  onMounted as g,
  onUnmounted as f,
  computed as E,
  reactive as b,
} from 'vue';
import { N as T, l as w, c as I } from './consumer-BZtQu-UF.js';
class r extends Error {
  // you'd think eslint would have a better feel for what's useless... anyway,
  // this constructor does have a use: to silence eslint, which, without it,
  // assumes derived classes can't possibly call `super(string)`, and the "fix"
  // that it helpfully applies is much worse.
  // perhaps TODO - coustomize our config so this rule ignores Errors?
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(t) {
    super(t);
    i(this, 'name', 'VueNotoUsageError');
  }
}
class h extends r {
  constructor(t, o, ...n) {
    super('VueConsumer in unexpected state!');
    i(this, 'name', 'BadVueNotoUsageStateError');
    i(this, 'attemptedAction');
    i(this, 'got');
    i(this, 'expected');
    (this.attemptedAction = t), (this.got = o), (this.expected = n.join('|'));
  }
}
class l extends r {
  constructor(t) {
    super('no notos can have been assigned before connecting!');
    i(this, 'name', 'NoVueNotoAssignmentsPossibleError');
    i(this, 'action');
    this.action = t ?? 'close';
  }
}
class S extends r {
  constructor() {
    super('a vue component cannot be a SYSTEM-level Noto consumer');
    i(this, 'name', 'BadVueNotoConsumerScopeError');
  }
}
function k(s) {
  if (s.scope === T.SYSTEM && !s.allowSystemScope) throw new S();
  const e =
      s.logger === null
        ? null
        : s.logger
        ? s.logger.getChild('vue-noto-consumer')
        : w.getChild('vue-consumer'),
    t = {
      scope: s.scope,
      types: s.types ? new Set(s.types) : null,
      cmp: s.cmp,
      logger: e,
      fallbackComponent: s.fallbackComponent ?? null,
      trackUnmounted: s.trackUnmounted ?? !0,
      trackMounted: s.trackMounted ?? !0,
      trackActivated: s.trackActivated ?? !1,
      ignoreMissingComponents: s.ignoreMissingComponents ?? !1,
      queueCallsWhileConnecting: s.queueCallsWhileConnecting ?? !0,
      componentMap: { ...s.componentMap },
      metaFilter: { ...s.metaFilter },
      onAssigned: s.onAssigned,
      onUpdated: s.onUpdated,
      onClosed: s.onClosed,
    };
  return y(t), t;
}
function y(s) {
  var e, t;
  if (!s.fallbackComponent && !s.ignoreMissingComponents)
    if (!s.types) (e = s.logger) == null || e.warn(A);
    else {
      const o = new Set(...s.types);
      for (const n in s.componentMap) o.delete(n);
      if (o.size > 0) {
        const n = v.replace('X', [...o].join(', '));
        (t = s.logger) == null || t.warn(n);
      }
    }
}
const A = `
  set to consume all types of noto with no fallbackComponent, this may result in
  undisplayable notos being assigned, which will be ignored, and not provided to
  the composable .noto array!
`
    .trim()
    .replace(/\S+/g, ' '),
  v = `
  though they are assignagble to this consumer, your componentMap does not
  include mappings for the following types: [X]. They will be ignored, and not
  provided to the composable .noto array!
`
    .trim()
    .replace(/\S+/g, ' ');
class D {
  constructor(e) {
    i(this, 'connectedRef');
    i(this, 'idRef');
    i(this, 'descriptor');
    i(this, 'handle');
    i(this, 'state');
    // we'll convert this before exposing directly to our caller
    i(this, 'notos');
    i(this, 'notoMap');
    // allow our composer to call the various methods before connection has
    // finished, so they don't have to make things too awkward in their setup
    // we might want to disable this behavior with an option in case they have
    // their own agenda and don't want to do stuff prior to connection.
    i(this, 'queuedCalls');
    // if we'll be sorting our notos as a part of the exposed computed prop, we'll
    // set this to our comparator. otherwise, leave it as null.
    i(this, 'cmp');
    // after figuring out what type gets what component, cache it here, marked as
    // raw where applicable. Should only be null in the strange case where our
    // composer has made it impossible to resolve a type.
    i(this, 'componentCache');
    // ensure we dont accidentally call lifecycle methods out of turn
    i(this, 'lifecycleTracked');
    (this.descriptor = k(e)),
      (this.state = 'INIT'),
      (this.handle = null),
      (this.connectedRef = a(!1)),
      (this.idRef = a(null)),
      (this.notos = a([])),
      (this.notoMap = {}),
      (this.componentCache = {}),
      (this.lifecycleTracked = !1),
      (this.queuedCalls = []),
      (this.cmp = this.descriptor.cmp
        ? this.compareVueNotos.bind(this, this.descriptor.cmp)
        : null);
  }
  // called by useVueNotoConsumer
  consume() {
    this.assertUsageState('INIT', 'call consume'), (this.state = 'CONNECTING');
    const e = {
      scope: this.descriptor.scope,
      types: this.descriptor.types,
      metaFilter: this.descriptor.metaFilter,
      onAssigned: this.onAssigned.bind(this),
      onUpdated: this.onUpdated.bind(this),
      onClosed: this.onClosed.bind(this),
    };
    return (
      this.trackVueLifecycle(),
      I(e).then(this.onConnected.bind(this)),
      d({
        id: this.idRef,
        connected: this.connectedRef,
        notos: this.getNotoComputed(),
        disconnect: this.useDisconnect.bind(this),
        setTypeFilter: this.useSetTypeFilter.bind(this),
        setActive: this.useSetActive.bind(this),
        setMetaFilter: this.useSetMetaFilter.bind(this),
        close: this.useClose.bind(this),
        action: this.useAction.bind(this),
      })
    );
  }
  // if the caller has indicated that they'd like us to manage vue lifecycle
  // hooks, do so now:
  trackVueLifecycle() {
    if (this.lifecycleTracked) throw new r('already tracked vue lifecycle!');
    (this.lifecycleTracked = !0),
      this.descriptor.trackActivated &&
        (m(this.useSetActive.bind(this, !0)),
        N(this.useSetActive.bind(this, !1))),
      this.descriptor.trackMounted && g(this.useSetActive.bind(this, !0)),
      this.descriptor.trackUnmounted && f(this.useDisconnect.bind(this));
  }
  /**
   * if our composer tried to make call on the consumer handle before we made a
   * connection, queue it up to be executed after the
   */
  queueCall(e) {
    if (
      (this.assertUsageState('CONNECTING', `queue call to ${e[0]}`),
      this.descriptor.queueCallsWhileConnecting)
    )
      this.queuedCalls.push(e);
    else throw new l(e[0]);
  }
  /**
   * execute and calls to the consumer that our consumer tried to make before
   * we actually had a handle
   */
  callQueuedActions() {
    var t;
    if ((this.assertUsageState('CONNECTED', 'make queued calls'), !this.handle))
      throw new r('somehow you got without a handle?');
    for (const [o, n] of this.queuedCalls) {
      const c = this[o];
      try {
        c.call(this, ...n);
      } catch (u) {
        (t = this.descriptor.logger) == null ||
          t.error('caught exception while executing queued calls:', {
            ex: u,
            name: o,
            args: n,
          });
      }
      if (o === 'useDisconnect') break;
    }
    this.queuedCalls.splice(0, 1 / 0);
  }
  async onConnected(e) {
    this.assertUsageState('CONNECTING', 'receive NotoConsumerHandle'),
      (this.handle = e),
      (this.connectedRef.value = !0),
      (this.idRef.value = e.id),
      (this.state = 'CONNECTED'),
      this.callQueuedActions();
  }
  getNotoComputed() {
    return this.cmp ? E(this.sortedAssignedNotos.bind(this)) : this.notos;
  }
  compareVueNotos(e, t, o) {
    return e(t.noto, o.noto);
  }
  sortedAssignedNotos() {
    if (!this.cmp) throw new Error('no comparator defined');
    return this.notos.value.sort(this.cmp);
  }
  // used as callback for registerConsumer
  onAssigned(e) {
    var n, c;
    (c = (n = this.descriptor).onAssigned) == null || c.call(n, e);
    const t = this.getComponent(e.type);
    if (!t) return;
    const o = b({
      key: `noto-${e.id}`,
      noto: e,
      component: t,
    });
    (this.notoMap[e.id] = o), this.notos.value.push(o);
  }
  // used as update callback for registerConsumer
  onUpdated(e) {
    var o, n;
    (n = (o = this.descriptor).onUpdated) == null || n.call(o, e);
    const t = this.notoMap[e.id];
    t && (t.noto = e);
  }
  findIndexById(e) {
    const t = this.notos.value;
    for (let o = 0; o < t.length; o++) if (t[o].noto.id === e) return o;
    return null;
  }
  // used as callback for registerConsumer
  onClosed(e, t) {
    var n, c;
    const o = this.findIndexById(e.id);
    (o !== null || this.notoMap[e.id]) &&
      ((c = (n = this.descriptor).onClosed) == null || c.call(n, e, t)),
      delete this.notoMap[e.id],
      o !== null && this.notos.value.splice(o, 1);
  }
  getHandle() {
    if (this.handle) return this.handle;
    throw new Error('missing noto consumer handle!!!');
  }
  // following methods are bound to the VueNotoUsage we return to our composer
  // so they can call disconnect, setActive, etc
  // (only reason these are public is so we can do the queue thing, class isn't
  // really meant to be handled directly, use "useVueNotoConsumer" instead)
  useDisconnect() {
    var e;
    switch (this.state) {
      case 'INIT':
        this.assertInitialized('call disconnect on consumer');
        break;
      case 'CONNECTING':
        this.queueCall(['useDisconnect', []]);
        break;
      case 'CONNECTED':
        (this.state = 'DISCONNECTED'),
          (this.connectedRef.value = !1),
          this.getHandle().disconnect();
        break;
      case 'DISCONNECTED':
        (e = this.descriptor.logger) == null ||
          e.warn('ignoring call to disconnect: consumer already disconnected');
        break;
    }
  }
  // bound to the VueNotoUsage we return to our composer
  useSetActive(e) {
    var t;
    switch (this.state) {
      case 'INIT':
        this.assertInitialized('call setActive on consumer');
        break;
      case 'CONNECTING':
        this.queueCall(['useSetActive', [e]]);
        break;
      case 'CONNECTED':
        this.getHandle().setActive(e);
        break;
      case 'DISCONNECTED':
        (t = this.descriptor.logger) == null ||
          t.warn('ignoring call to setActive: consumer already disconnected');
        break;
    }
  }
  // bound to the VueNotoUsage we return to our composer
  useSetMetaFilter(e) {
    var t;
    switch (this.state) {
      case 'INIT':
        this.assertInitialized('call setActive on consumer');
        break;
      case 'CONNECTING':
        this.queueCall(['useSetMetaFilter', [{ ...e }]]);
        break;
      case 'CONNECTED':
        this.getHandle().setMetaFilter({ ...e });
        break;
      case 'DISCONNECTED':
        (t = this.descriptor.logger) == null ||
          t.warn(
            'ignoring call to setMetaFilter: consumer already disconnected',
          );
        break;
    }
  }
  // bound to the VueNotoUsage we return to our composer
  useSetTypeFilter(e) {
    var t;
    switch (this.state) {
      case 'INIT': {
        this.assertInitialized('call setActive on consumer');
        return;
      }
      case 'CONNECTING':
        this.queueCall(['useSetTypeFilter', [e ? new Set(e) : null]]);
        break;
      case 'CONNECTED':
        this.getHandle().setTypeFilter(e ? new Set(e) : null);
        break;
      case 'DISCONNECTED':
        (t = this.descriptor.logger) == null ||
          t.warn(
            'ignoring call to setTypeFilter: consumer already disconnected',
          );
        break;
    }
  }
  // bound to the VueNotoUsage we return to our composer
  useClose(e) {
    var t;
    switch (this.state) {
      case 'INIT':
      case 'CONNECTING':
        throw new l(`close noto id=${e}`);
      case 'CONNECTED':
        this.getHandle().close(e);
        break;
      case 'DISCONNECTED':
        (t = this.descriptor.logger) == null ||
          t.warn('ignoring call to close: consumer already disconnected');
        break;
    }
  }
  // bound to the VueNotoUsage we return to our composer
  useAction(e, t, o) {
    var n;
    switch (this.state) {
      case 'INIT':
      case 'CONNECTING':
        throw new l(`act on noto id=${e}`);
      case 'CONNECTED':
        this.getHandle().action(e, t, o);
        break;
      case 'DISCONNECTED':
        (n = this.descriptor.logger) == null ||
          n.warn('ignoring call to action: consumer already disconnected');
        break;
    }
  }
  /**
   * throw an error if state is not the current state.
   * @param state — the required state
   * @param desc — an optional description to include with the error, e.g.:
   *   "connect" so it says "cannnot connect, expected state X etc etc..."
   * @throws BadVueNotoUsageStateError
   */
  assertUsageState(e, t) {
    if (!this.isUsageState(e)) throw new h(t ?? 'comply', e, this.state);
  }
  /**
   * throw an error if state is not past INIT
   * @param desc — an optional description to include with the error, e.g.:
   *   "connect" so it says "cannnot connect, expected state X etc etc..."
   * @throws BadVueNotoUsageStateError
   */
  assertInitialized(e) {
    if (
      this.isUsageState(
        'INIT',
        /* INIT */
      )
    )
      throw new h(
        e ?? 'comply',
        this.state,
        'CONNECTING',
        'CONNECTED',
        'DISCONNECTED',
        /* DISCONNECTED */
      );
  }
  /** returns true if the given state is the current state. */
  isUsageState(e) {
    return this.state === e;
  }
  /**
   * get the component associated with a specific noto type, caching the results
   * if we haven't already.
   */
  getComponent(e) {
    if (this.componentCache[e]) return this.componentCache[e];
    const t = this.resolveUncachedComponent(e);
    return (this.componentCache[e] = t ? d(t) : null), t;
  }
  /** calculate the component to use for a noto type before it's been cached */
  resolveUncachedComponent(e) {
    var o, n;
    const t =
      ((o = this.descriptor.componentMap) == null ? void 0 : o[e]) ??
      this.descriptor.fallbackComponent;
    return (
      t ||
      (this.descriptor.ignoreMissingComponents
        ? M
        : ((n = this.descriptor.logger) == null ||
            n.error(
              `no component matched Noto of type ${e}: they can never be displayed!`,
            ),
          null))
    );
  }
}
const M = d({});
function q(s) {
  return new D(s).consume();
}
export { q as useVueNotoConsumer };
